import React from 'react';
import { EditorView } from '@codemirror/view';
import { Compartment } from '@codemirror/state';
import { useCodeMirror } from '@ui-schema/kit-codemirror/useCodeMirror';
import { useEditorClasses } from '@ui-schema/kit-codemirror/useEditorClasses';
export const CodeMirror = ({
  className,
  classNamesContent,
  onChange,
  onViewLifecycle,
  onExternalChange,
  value = '',
  style,
  extensions,
  effects
}) => {
  const containerRef = React.useRef(null);
  const editorAttributesCompartment = React.useRef(new Compartment());
  const extensionsAll = React.useMemo(() => [editorAttributesCompartment.current.of(EditorView.editorAttributes.of({})), ...(extensions || [])], [extensions]);
  const editor = useCodeMirror(onChange, value, extensionsAll, effects, containerRef, onExternalChange, onViewLifecycle);
  useEditorClasses(editorAttributesCompartment.current, editor, classNamesContent);
  return React.createElement("div", {
    className: className,
    style: style,
    ref: containerRef
  });
};